import { ArrowRight, BookOpen, CalendarDays, Sparkles } from "lucide-react";
import { ButtonLink } from "@/components/ButtonLink";
import { ConceptCard } from "@/components/ConceptCard";
import { Countdown } from "@/components/Countdown";
import { SectionHeading } from "@/components/SectionHeading";
import { WorldPulse } from "@/components/WorldPulse";
import { conceptGallery, developmentPoints, featureCards } from "@/data/site";
import { useI18n } from "@/i18n/I18nProvider";

export function Home() {
  const { t } = useI18n();

  return (
    <>
      <section className="hero">
        <img className="hero-art" src="/concepts/verdantfall-hero.png" alt="" aria-hidden="true" />
        <div className="hero-vignette" aria-hidden="true" />
        <div className="hero-content" data-reveal>
          <p className="eyebrow">{t("home.hero.eyebrow")}</p>
          <h1>{t("home.hero.title")}</h1>
          <p>{t("home.hero.body")}</p>
          <div className="hero-actions">
            <ButtonLink href="/world">
              <Sparkles size={18} />
              {t("home.hero.primary")}
            </ButtonLink>
            <ButtonLink href="/media" variant="secondary">
              <BookOpen size={18} />
              {t("home.hero.secondary")}
            </ButtonLink>
          </div>
        </div>
        <WorldPulse />
      </section>

      <section className="status-band">
        <div className="section-inner status-grid">
          <div data-reveal>
            <h2>{t("home.status.title")}</h2>
          </div>
          <p data-reveal>{t("home.status.body")}</p>
        </div>
      </section>

      <section className="content-band">
        <div className="section-inner">
          <SectionHeading title={t("home.pillars.title")} body={t("home.pillars.lead")} />
          <div className="feature-grid">
            {featureCards.map((card) => {
              const Icon = card.icon;
              return (
                <article className="feature-card" key={card.titleKey} data-reveal>
                  <Icon size={24} />
                  <h3>{t(card.titleKey)}</h3>
                  <p>{t(card.bodyKey)}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="image-band">
        <div className="section-inner split-layout">
          <div data-reveal>
            <p className="eyebrow">{t("common.conceptNotice")}</p>
            <h2>{t("home.showroom.title")}</h2>
            <p>{t("home.showroom.body")}</p>
            <div className="inline-actions">
              <ButtonLink href="/media" variant="secondary">
                {t("common.viewMedia")}
                <ArrowRight size={17} />
              </ButtonLink>
            </div>
          </div>
          <ConceptCard concept={conceptGallery[1]} />
        </div>
      </section>

      <section className="content-band parchment-band">
        <div className="section-inner split-layout reverse">
          <div className="development-panel" data-reveal>
            {developmentPoints.map((point) => (
              <div className="ledger-row" key={point}>
                <span />
                <p>{t(point)}</p>
              </div>
            ))}
          </div>
          <div data-reveal>
            <p className="eyebrow">{t("common.inDevelopment")}</p>
            <h2>{t("home.development.title")}</h2>
            <p>{t("home.development.body")}</p>
          </div>
        </div>
      </section>

      <section className="release-band">
        <div className="section-inner release-grid">
          <div data-reveal>
            <CalendarDays size={28} />
            <h2>{t("home.release.title")}</h2>
            <p>{t("home.release.body")}</p>
          </div>
          <Countdown />
        </div>
      </section>
    </>
  );
}
